// Presentation-only list of what the subscription includes.
//
// PM 04.08.2026 item 7: these used to be rendered ONLY on the purchase offer
// card, so a subscriber could never see what their package covered once they
// had bought it. The subscription card now renders the same list, which is
// why the strings live here instead of being inlined in the offer card's
// markup -- one list, two surfaces, no chance of them drifting apart.
//
// Values are i18n keys resolved by the rendering component. They are the
// Turkish source strings, so an absent translation falls back to the key and
// still renders correctly -- the behaviour these had when they were inline.
export const SUBSCRIPTION_PACKAGE_FEATURES = Object.freeze([
  'Danışan Yönetim Sistemi',
  'Grup Belirleme Testi (GBT)',
  'Gelişim Egzersizleri Kütüphanesi',
  'Online Seans Altyapısı',
  'Entegre Organizer Takvim',
  'Dijital Raporlama Sistemi',
  'Esnek Uygulama Modülü',
  'Bayilik veya Katılım Ücreti Yok',
])

export default SUBSCRIPTION_PACKAGE_FEATURES
